<template>
    <div>
         <div v-if="camposRequeridosDeFormulario.tipoDeFormulario == 'comunicado' || paginaWebId == 29 || paginaWebId == 1">
            <h6><b>Descripción de los iconos</b>&nbsp;<i class="fas fa-caret-down fa-lg" @click="mostrarDescripcionDeIconos = !mostrarDescripcionDeIconos"></i></h6>
            <table id="descripcion-iconos-table" class="col-12" v-if="mostrarDescripcionDeIconos">
                <tbody>
                <tr>
                        <td><i class="fas fa-eye fa-lg p-1"></i></td>
                        <td v-if="camposRequeridosDeFormulario.tipoDeFormulario == 'comunicado'"><h6><b>Mostrar en inicio:</b>&nbsp;Representa los contenidos que se mostrarán en el menú lateral derecho de la página oficial.</h6></td>
                        <td v-if="paginaWebId == 29"><h6><b>Mostrar en inicio:</b>&nbsp;Representa el boletín electrónico que se mostrará en la barra superior de la página oficial.</h6></td>
                        <td v-if="paginaWebId == 1"><h6><b>Mostrar en inicio:</b>&nbsp;Representa el informe laboral que se mostrará en la barra superior de la página oficial.</h6></td>
                </tr>
                <tr v-if="paginaWebId == 19">
                        <td><i class="fas fa-exclamation fa-lg p-1"></i></td>
                        <td><h6><b>Noticia Urgente:</b>&nbsp;Representa la noticia con estatus de urgente que se mostrará como sección emergente al momento de visitar la página oficial.</h6></td>
                </tr>
                <tr v-if="camposRequeridosDeFormulario.tipoDeFormulario == 'comunicado'">
                        <td><i class="fas fa-thumbtack fa-lg p-1"></i></td>
                        <td><h6><b>Pin:</b>&nbsp;Representa el contenido que se fijará al inicio dentro del menú lateral derecho de la página oficial, si éste está activo también lo estará mostrar en inicio.</h6></td>
                </tr>
                <tr v-if="paginaWebId == 19">
                        <td><i class="fas fa-layer-group fa-lg p-1"></i></td>
                        <td><h6><b>Disposición Especial:</b>&nbsp;Representa los contenidos que son dispisición especial y tendrán un vínculo directo en el menú de "Disposiciones Especiales" de la página oficial.</h6></td>
                </tr>
                </tbody>
            </table>
            <hr/>
        </div>
        <div class="lista-contenidos row-5">
            <ListaOrdenableDeContenido
                :esParaEdicion="true"
                :listaDeContenidos="contenidos"
                :camposRequeridosEnFormulario="camposRequeridosDeFormulario"
                :paginaWebId="paginaWebId"
                :seccionId="seccionId"
                :key="'KEYListaOrdenableVEDC' + contRenderLista"></ListaOrdenableDeContenido>
        </div>
    </div>
</template>
<script>
import ListaOrdenableDeContenido from '@/components/SICPO/PaginaWeb/AltaDeContenido/ListaOrdenableDeContenido.vue'
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"

export default {
    components: {
        ListaOrdenableDeContenido: ListaOrdenableDeContenido
    },
    props: {
        listaDeContenidos: {
            type: Array,
            default: () => []
        },
        camposRequeridosDeFormulario: {
            type: Object,
            default: () => ({})
        },
        paginaWebId: {
            type: Number,
            default: -1
        },
        seccionId: {
            type: Number,
            default: -1
        },
    },
    data() {
        return {
            mostrarDescripcionDeIconos: false,
            contenidos: [],
            listaDeContenidosNuevoOrden: [],
            contRenderLista: 0
        }
    },
    methods: {
        mapearInformacionParaListado: async function() {
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            let esComunicado = this.camposRequeridosDeFormulario.tipoDeFormulario == 'comunicado' ? true : false;
            let esBoletinElectronicoOInformeLaboral = this.paginaWebId == 29 || this.paginaWebId == 1;
            for(var i=0;i<this.listaDeContenidos.length;i++){
                let icoMostrar =  (i < 3 && esComunicado? true: false) || (i==0 && esBoletinElectronicoOInformeLaboral);
                if( esComunicado &&
                    this.listaDeContenidos[i].EsUrgente &&
                    (new Date(this.listaDeContenidos[i].FechaDePublicacion) <= hoy && new Date(this.listaDeContenidos[i].FechaDePublicacionFinal) >= hoy))
                {
                    if(urgenteVisibleId != -1)
                        urgenteVisibleId = this.listaDeContenidos[urgenteVisibleId].FechaDeRegistro > this.listaDeContenidos[i].FechaDeRegistro? 
                                            urgenteVisibleId : i;
                    else urgenteVisibleId = i; 
                }

                let elementoContenido = {
                    id: i, 
                    mostrarDescripcion:false, 
                    hover:false,
                    conIconoUrgenteVisible: false,
                    conIconoMostrarEnInicio: icoMostrar,
                    contenido: this.listaDeContenidos[i]
                }
                listaContenidosOriginal.push(elementoContenido);
            }
            if(esComunicado && urgenteVisibleId!=-1)
                listaContenidosOriginal[urgenteVisibleId].conIconoUrgenteVisible = true;
            this.contenidos = listaContenidosOriginal;
            this.contRenderLista ++;
        },
         guardarOrdenDeContenidos: function() {
            comun.SeEstaCargandoInformacion(true);
            this.generarListadoConNuevoOrden();
            let esComunicado = this.camposRequeridosDeFormulario.tipoDeFormulario == 'comunicado' ? true : false;
            const parametros = {}
            parametros.ContenidosDeLaPaginaWeb = this.listaDeContenidosNuevoOrden;
            parametros.SeccionDeLaPaginaWebId = this.seccionId;
            parametros.EsComunicado = esComunicado;

            // api.SICPO.funcion.ModificarOrdenDeContenidosComunicados
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.altadecontenido.ModificarOrdenDeContenidosComunicados;

            axios.post(api.conexion + METODO_API_AGREGAR,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                comun.SeEstaCargandoInformacion(false);
                if (respuesta.data.SiHayError) {
                    console.log(respuesta); 
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } 
                else {
                    /* this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false); */
                    //this.mapearInformacionParaListado()
                    this.$emit("ActualizarContenidos",respuesta.data.Satisfactorio);
                    //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                }
            }).catch(excepcion => {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            });
        },
        /**
         * Metodo encargado de asignar el nuevo orden que tendra cada uno de los contenidos de la lista, desplazando
         * un lugar antes o despues segun la interaccion del usuario.  
         */
        generarListadoConNuevoOrden: function() {
            this.listaDeContenidosNuevoOrden = [];
            let listado = this.contenidos;
            for(var i=0;i<listado.length;i++){
                let contenido = listado[i].contenido;
                contenido.OrdenDelContenido = i+1;
                this.listaDeContenidosNuevoOrden.push(contenido);
            }
        }
    },
    async created() {
        if(this.listaDeContenidos != null || this.listaDeContenidos != undefined)
            await Promise.resolve(this.mapearInformacionParaListado());
    },
}
</script>
<style scoped>
#descripcion-iconos-table td {
    color: white;
}

.lista-contenidos {
    max-height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/EdicionDeContenido/COrdenamientoDeContenidos.vue